import { gql } from 'apollo-angular';
import {
  paginationQuery,
  propertyPsSide,
  rentDepositInfoFields
} from '@ui/legacy-lib';

/**
 * The tenant's rented objects.
 *
 * Trimmed against the app's `propertyApplyProcessFields`
 * (`apps/tenant-pool/src/app/core/queries/property-searcher.queries.ts`): the
 * rented list only ever renders `id`, `type`, `status`, `property` and
 * `rentDepositInfo`, so the apply-flow fields are dropped —
 * `captchaSettings`, `questionContainer`, `hasQuestions`,
 * `hasUnansweredQuestions`, `conversationExists`, `allowedToSendMessage`,
 * `askForViewingAppointmentAttendance`, `smsVerificationRequired`,
 * `customerId`, `appointmentSlotsAvailable`, `upcomingAppointmentDate` and
 * `upcomingAppointmentId`.
 *
 * Dropping `captchaSettings` is what keeps this file free of a copy of
 * `captchaSettingsFields`, which is declared in `apps/` and is therefore
 * unreachable from a lib.
 *
 * `propertyPsSide` and `rentDepositInfoFields` are interpolated whole and
 * deliberately NOT trimmed — they feed `app-property-card`,
 * `app-application-status-pipeline` and the rent-deposit cards, whose field
 * appetite is spread across several components and changes without touching
 * this file. They stay raw interpolated strings rather than named GraphQL
 * fragments so `graphql-tag` cannot collide with the app's copies.
 */
export const rentedPropertyMatchesQuery = gql`
  query propertyApplyProcessRented($filter: Filter) {
    propertyApplyProcessRented(filter: $filter) {
      nodes {
        id
        type
        status
        rentDepositInfo {
          ${rentDepositInfoFields}
        }
        ${propertyPsSide}
      }
      page {
        ${paginationQuery}
      }
    }
  }
`;
